import { styled, StyleProps, CSS } from "../../styles"

export const DialogTitle = styled.div(
  (props: StyleProps): CSS => ({
    padding: props.theme.spacing(6, 7, 0),
  })
)
